import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LandingPagesService } from '../service/landing-pages.service';

// A client with a bad link sees a public bilingual page with contact options,
// never the staff login.
export const affiliateLinkGuard: CanActivateFn = (route, _state) => {
  const landingService = inject(LandingPagesService);
  const router = inject(Router);

  const code: string | undefined = route.queryParams['c'];

  if (!code) {
    router.navigate(['/landingPage/invalid-link']);
    return of(false);
  }

  return landingService.getAffiliateInvite(code).pipe(
    map(({ idUser }) => {
      if (!idUser) {
        router.navigate(['/landingPage/invalid-link']);
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigate(['/landingPage/invalid-link']);
      return of(false);
    })
  );
};
